
<div  class="pdf-print-view" [innerHTML]="invoiceData">
</div>
<div style="margin-top:20px; text-align: center;" class="d-flex justify-content-center actionbtn">
	<button class="btn-style bg-green" (click)="downloadPdf(searchId)">Print</button>
</div>
